module.exports = __webpack_public_path__ + "static/img/joinus-pic.a6a854ee.jpg";